module.exports = __webpack_public_path__ + "static/media/apk_icon.aaa63e75.svg";